import React from "react"
import moment from "moment"
import { HotelContractModel, SeasonModel } from "../../models"
import styles from "./hotelRates.module.scss"
import { toTitleCase } from "util/textcase"

type Props = {
    contract: HotelContractModel | null
    contractIndex?: number
}

const formatDateRange = (start: string | number, end: string | number): string => {
    const startM = moment(start)
    const endM = moment(end)
    if (!startM.isValid() || !endM.isValid()) return ""
    return `${startM.format("MMM DD, YYYY")} To ${endM.format("MMM DD, YYYY")}`
}

const formatSeasonRanges = (season: SeasonModel): string => {
    const ranges = (season.season_date_range || [])
        .filter((r) => r.season_start_date != null && r.season_end_date != null)
        .map((r) => formatDateRange(r.season_start_date, r.season_end_date))
        .filter(Boolean)
    return ranges.join(", ")
}

const ContractSeasonDatesBar: React.FC<Props> = ({ contract, contractIndex = 0 }) => {
    if (!contract || !contract.season || contract.season.length === 0) return null

    const seasonsWithRanges = contract.season
        .filter((s) => s.season_name)
        .map((s) => ({
            name: s.season_name!,
            ranges: formatSeasonRanges(s),
        }))
        .filter((s) => s.ranges.length > 0)

    if (seasonsWithRanges.length === 0) return null

    const contractLabel = contractIndex != null && contractIndex >= 0 ? `Contract ${contractIndex + 1}` : "Contract"
    const parts = seasonsWithRanges.map(
        (s) =>
            `${s.name}: ${s.ranges}`
    )

    return (
        <div className={styles.contractSeasonDatesBar} role="status" aria-label="Contract season dates">
            <span className={styles.contractSeasonDatesLabel}>{contractLabel}:</span>
            {parts.map((part, idx) => {
                const colonIndex = part.indexOf(":")
                const label = colonIndex >= 0 ? part.slice(0, colonIndex) : part
                const value = colonIndex >= 0 ? part.slice(colonIndex + 1).trim() : ""
                return (
                    <span key={idx} className={styles.contractSeasonDatesPart}>
                        {idx > 0 && <span className={styles.contractSeasonDatesSeparator}> | </span>}
                        <strong>{toTitleCase(label)}:</strong> {toTitleCase(value)}
                    </span>
                )
            })}
        </div>
    )
}

export default ContractSeasonDatesBar
